export const MAX_ENTRIES_PER_PAGE = 25;
